import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/projets',
        name: 'projets',
        component: () => import('../views/Projects.vue')
    },
    /*
    {
        path: '/ecole',
        name: 'ecole',
        component: () => import('../views/Ecole.vue')
    },
    */
    {
        path: '/partenaires',
        name: 'partenaires',
        component: () => import('../views/Partenaires.vue')
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: () => import('../views/Contacts.vue')
    },
    {
        path: '/projet/:idProject',
        name: 'projet',
        component: () => import('../views/ProjectDetails.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('../views/NotFound.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
    }
})

export default router
